import { useState, useEffect } from 'react'

import './App.css';
import Header from './components/Header.js'
import CocktailItem from './components/CocktailItem';
import ShowCocktailInstruction from './components/ShowCocktailInstruction';


import SadFace from './resources/sadface_79592.svg'

function App() {
  const [showCocktailDetails, setShowCocktailDetails] = useState([])
  const [data, setData] = useState([])

  const handleShowCocktailDetails = async (idDrink, show) => {
    if (show) {
      const API_URL = 'https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i='
      const newCocktailDetails = await (await fetch(API_URL + idDrink)).json()
      setShowCocktailDetails(await newCocktailDetails.drinks)
    }
    else {
      setShowCocktailDetails([])
    }
  }

  const handleSearchDrink = async (nameDrink) => {
    if (nameDrink === '') {
      GetData()
    }
    else {
      const API_URL = 'https://www.thecocktaildb.com/api/json/v1/1/search.php?s='
      const newDataWithSearch = await (await fetch(API_URL + nameDrink)).json()
      if (await newDataWithSearch === null) {
        setData([])
      }
      else {
        setData(newDataWithSearch.drinks)
      }
    }

  }

  const GetData = async () => {
    const res = await (await fetch('https://www.thecocktaildb.com/api/json/v1/1/search.php?f=a')).json()
    setData(await res.drinks)
  }
  useEffect(() => {
    GetData()
  }, [])

  return (
    <div className="App">
      {
        (showCocktailDetails.length === 0) ?
          <>
            <Header handleSearchDrink={handleSearchDrink} />
            <main>
              {
                data === null
                  ?
                  <div className='loadingResources'>
                    <img src={SadFace} alt='SadFace' />
                    <h1>We can't found results</h1>
                  </div>
                  : <>
                    {
                      data.map(drink =>
                      (<CocktailItem key={drink.idDrink}
                        id={drink.idDrink} drink={drink.strDrink}
                        imageURL={drink.strDrinkThumb}
                        instruction={drink.strInstructions}
                        handleShowCocktailDetails={handleShowCocktailDetails} />))
                    }
                    <h2>There is nothing else around here <br />:D</h2>
                  </>

              }
            </main>
          </>
          : <ShowCocktailInstruction key={showCocktailDetails.length} handleShowCocktailDetails={handleShowCocktailDetails} nameDrink={showCocktailDetails[0].strDrink} imageURL={showCocktailDetails[0].strDrinkThumb} ingredients={[showCocktailDetails[0].strIngredient1, showCocktailDetails[0].strIngredient2, showCocktailDetails[0].strIngredient3, showCocktailDetails[0].strIngredient4, showCocktailDetails[0].strIngredient5]} instruction={showCocktailDetails[0].strInstructions} />
      }
    </div>
  );
}

export default App;
